import { IPalletByKavItem } from '../../../../../../modules/API/Distribution/models/palletByKav'
import TitleLayout from '../../../kosherTeudot/generic/TitleLayout'
import TitleRow from '../../../kosherTeudot/generic/TitleRow'
import TitleRowItem from '../../../kosherTeudot/generic/TitleRowItem'
import InvoiceIcon from '../../../../../../generic/icons/IconLib/InvoiceIcon'
import MinusIcon from '../../../../../../generic/icons/IconLib/MinusIcon'
import PalletIcon from '../../../../../../generic/icons/IconLib/PalletIcon'
import PlusIcon from '../../../../../../generic/icons/IconLib/PlusIcon'
import UserIcon from '../../../../../../generic/icons/IconLib/UserIcon'
import styled from 'styled-components'
import { IPutPalletStatus } from '../../../../../../modules/API/Distribution/models/fetchData'

interface Props extends IPalletByKavItem  {
  putPalletStatus: (data: IPutPalletStatus) => void
}

const PalletItem = ({
  Status, Pallet_Num, Delivery_Num, putPalletStatus, CustomerDesc
}: Props) => {

 
  const handleClick = () => {
    putPalletStatus({
      Pallet_Num,
      Status: Status === 0 ? 7 : 0
    })
  }
  // const palletDesk = useMemo(() => {
  //   const status = Status as keyof typeof PalletStatuses
  //   return PalletStatuses[status]
  // }, [Status])
  return (
    <TitleLayout
      borderColor={
        Status === 0 ? 'tomato' : 
        Status === 7 ? "rgb(128, 224, 129)" : ''
      }
    >
      <SideWrapper
        $color={Status === 0 ? "#80E081" : 'tomato'}
        onClick={handleClick}
      >
        {
          Status === 0 ? (
            <PlusIcon />
          )
          :
          Status === 7 ? (
           <MinusIcon />

          )
          : ""
        }
      </SideWrapper>
      <TitleRow>
        <TitleRowItem
          name={Delivery_Num}
          icon={<InvoiceIcon />}
        />
        <TitleRowItem 
          name={Pallet_Num}
          icon={<PalletIcon />}
        />
      </TitleRow>
      <TitleRow>
        <TitleRowItem
          name={CustomerDesc.trim()}
          icon={<UserIcon />}
        />
      </TitleRow>
    </TitleLayout>
  )
}

const SideWrapper = styled.div<{$color: string}>`
  position: absolute;
  top: 0;
  left: 0;
  width: 4em;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  svg {
    color: ${props => props.$color};
  }
`
export default PalletItem